import React from "react";
import { LoadingSpinner } from "../../atoms";

interface LoadingBlurDivProps extends React.HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean;
  children?: React.ReactNode;
}

export const LoadingBlurDiv = React.forwardRef<HTMLDivElement, LoadingBlurDivProps>(
  ({ isLoading = false, children, className = "", ...props }, ref) => {
    return (
      <div ref={ref} className={`relative ${className}`} {...props}>
        {isLoading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-(background-1)/60 backdrop-blur-sm rounded-lg">
            <LoadingSpinner />
          </div>
        )}
        {children}
      </div>
    );
  }
);

LoadingBlurDiv.displayName = "LoadingBlurDiv";